export default __webpack_public_path__ + "static/media/4.bc34132c.jpeg";